import styled from '@emotion/styled';
import HorizontalFlex from '../../../components/flex_layouts/HorizontalFlex';
import TableTabs from './TableTabs';
import TableSearchField from './TableSearchField';
import { forwardRef, Ref } from 'react';

const TableHeader = ({ ...props }, ref: Ref<HTMLDivElement>) => (
  <LayoutRoot {...props}>
    <TableTabs ref={ref} />
    <TableSearchField />
  </LayoutRoot>
);

export default forwardRef(TableHeader);

const LayoutRoot = styled(HorizontalFlex)`
  width: 100%;
  gap: 20px;
  justify-content: space-between;

  @media print {
    padding: 0 16px;
  }

  @media (max-width: 1044px) {
    flex-direction: column;
  }
`;
